<template>
	<div class="g-product-card g-product-card__hoverable g-layout__item" :data-gtm-name="result.name" :data-gtm-id="result.ss_sku" :data-gtm-price="result.price" :data-gtm-category="result.gtm_category" :data-gtm-sku="result.ss_sku">
		<a class="g-product-card__link" :href="result.url | rewriteUrl" :title="'View ' + result.name" @mousedown="intelliSuggest($event, result)">
			<div class="g-product-card__image">
				<span v-if="result.flag && result.flag.length" class="g-product-flag g-flag-style-1">{{result.flag}}</span>
				<img :src="getProductImage(result)" @error="setErrorImage" @mouseenter="productImageSwap(result, $event)" @mouseleave="productImageSwap(result, $event)" :alt="result.name" class="g-product-card__image-source" height="308" width="216" loading="lazy" />
			</div>
			<div class="g-product-card__footer">
				<div class="g-product-card__name" v-html="result.name"></div>
				<div class="g-product-card__information">
					<div class="g-product-card__pricing">
						<s v-if="result.original_price > result.price" class="g-product-card__base-price">
							<span class="u-hide-visually">Original Price: </span>
							{{ result.original_price | toCurrency }}
						</s>
						<span class="g-product-card__price">
							<span v-if="result.original_price > result.price" class="u-hide-visually">Sale Price: </span>
							<span v-else class="u-hide-visually">Price: </span>
							{{ result.price | toCurrency }}
						</span>
					</div>
				</div>
				<div class="g-product-card__shipping">
					<span v-if="result.instore_only === 'yes'" class="g-flag-shipping">
						<span class="g-product-card__shipping-icon u-icon-pickup"></span> In Store Only
					</span>
					<span v-if="result.pickup_only === 'yes'" class="g-flag-shipping">
						<span class="g-product-card__shipping-icon u-icon-pickup"></span> Pick Up Only
					</span>
					<span v-else-if="result.currently_unavailable === 'yes'" class="g-flag-shipping">
						<span class="g-product-card__shipping-icon u-icon-cross"></span> Unavailable
					</span>
					<span v-else>&nbsp;</span>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				errorImage:  mivaJS.Image_Placeholder_Product_Empty,
				loadingImage: mivaJS.Image_Placeholder_Product_Empty,
				noImage: mivaJS.Image_Placeholder_Product_No_Image,
				damActive: mivaJS.DAM_Active,
				damTransformations: '?tx=f_auto,w_216,h_308'
			}
		},
		props: {
			result: {
				default() {
					return {};
				}
			}
		},
		methods: {
			productImageSwap(data, event) {
				const imageElement = event.target;
				const eventType = event.type;

				let mainImageThumbnail = this.damActive ? data.thumbnailImageUrl + this.damTransformations : data.thumbnailImageUrl;
				let swapImageThumbnail = data.hover_image && data.hover_image.length ? data.hover_image : null;

				if (!swapImageThumbnail) {
					return;
				}

				if (this.damActive && swapImageThumbnail) {
					swapImageThumbnail = swapImageThumbnail + this.damTransformations;
				}

				const isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0;
				const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

				if (!isTouchDevice && !isMobileDevice) {
					switch (eventType) {
						case 'mouseenter':
							imageElement.src = swapImageThumbnail;
							break;
						case 'mouseleave':
							imageElement.src = mainImageThumbnail;
							break;
						default:
							return;
					}
				}
			},
			getProductImage(data) {
				let image = '';

				if (typeof data.thumbnailImageUrl !== 'undefined') {
					image = data.thumbnailImageUrl;

					if (this.damActive) {
						image =  image + this.damTransformations;
					}
				} else {
					image = this.noImage;
				}

				return image;
			},
			setErrorImage(event) {
				event.target.src = this.errorImage;
			},
			intelliSuggest(e,data) {
				const itemLink = e.target.closest('a');
				const imgTag = new Image;
				imgTag.src= `https://${mivaJS.SS_SITE_ID}.a.searchspring.io/api/track/track.json?d=${data.intellisuggestData}&s=${data.intellisuggestSignature}&u=${encodeURIComponent(itemLink.href)}&r=${encodeURIComponent(document.referrer)}`;
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "variables";

	.g-product-card {

		.g-product-card__shipping {

			.g-flag-shipping {
				margin-bottom: $unit-small;
			}

			.g-flag-shipping--delivery-only {
				background: $message-success-background;
				color: $message-success-text;
			}
		}
	}

</style>